import AppColors from "./appColors";
import AppIcons from "./appIcons";
import { isMobile } from "./responsiveUtil";

const graphList = [
  {
    percentage: "9%",
    height: 160,
    rateOfInterest: 9,
    title: "ADITI",
    gradientColor1: AppColors.green,
    gradientColor2: AppColors.darkGreen,
    secondaryColor: AppColors.green01,
  },
  {
    percentage: "4%",
    rateOfInterest: 4,
    height: 60,
    title: "Savings Acc",
    gradientColor1: AppColors.brown,
    gradientColor2: AppColors.darkBrown,
    secondaryColor: AppColors.brown01,
  },
  {
    percentage: "0%",
    rateOfInterest: 0,
    height: 16,
    title: "Idle Funds",
    gradientColor1: AppColors.red,
    gradientColor2: AppColors.darkRed,
    secondaryColor: AppColors.red01,
  },
];

const videoCarousel = [
  {
    thumbnail: AppIcons.imgAditiThumbnail1,
    videoUrl:
      "https://mahilamoney-community-prod.s3.ap-south-1.amazonaws.com/posts/95c7fab6-680a-4217-9557-071569441753LandingPageVideo1.mp4",
  },
  {
    thumbnail: AppIcons.imgAditiThumbnail2,
    videoUrl:
      "https://mahilamoney-community-prod.s3.ap-south-1.amazonaws.com/posts/7325cb6d-a476-4dd2-9f41-e1fe4c09f053LandingPageVideo2.mp4",
  },
  {
    thumbnail: AppIcons.imgAditiThumbnail3,
    videoUrl:
      "https://mahilamoney-community-prod.s3.ap-south-1.amazonaws.com/posts/d40abab6-a8fc-44ee-a178-f1ef5d6ac127LandingPageVideo3.mp4",
  },
];

const mutualFundsList = [
  {
    icon: AppIcons.icAditiFund1,
    title: "Earn 9% Interest p.a.*",
    desc: "Get back higher returns when compared to traditional investments.",
  },
  {
    icon: AppIcons.icAditiFund2,
    title: "3 months Lock-in Period",
    desc: "Enjoy lower lock-in period with easy withdrawal option.",
  },
  {
    icon: AppIcons.icAditiFund3,
    title: "Invest at Your Own Pace",
    desc: "Continue to build your financial portfolio anytime, anywhere.",
  },
];

const stepsList = [
  {
    icon: AppIcons.icAditiStep1,
    title: "Register with your mobile number",
    desc: "Get OTP to  authenticate",
  },
  {
    icon: AppIcons.icAditiStep2,
    title: "Verify your documents hasse-free",
    desc: "Keep your PAN and Aadhar Card details ready to verify without uploading the same",
  },
  {
    icon: AppIcons.icAditiStep3,
    title: "Add Bank Account Details",
    desc: "Make sure to add a valid bank account number to invest and receive funds on maturity seamlessly.",
  },
  {
    icon: AppIcons.icAditiStep4,
    title: "Choose the investment amount and tenure",
    desc: "Complete your payment and START Investing",
  },
];

const aditiFaqsList = [
  {
    question: "What is the Aditi Investment Plan?",
    answer:
      "Aditi Investment Plan is an investment opportunity to grow your wealth and earn a 9% annual interest income. Build or expand your #JiyoApneDumPe financial portfolio by investing from INR 3,000 up to INR 10,00,000.",
  },
  {
    question: "How does Aditi Investment Plan (powered by RupeeCircle) work?",
    answer:
      "When you invest a certain amount in Aditi Investment Plan, RupeeCircle,  RBI-licensed NBFC-P2P Partner, gives it to credit-worthy borrowers seeking loans. This creates an opportunity for you as an investor to earn higher returns on your investments. ",
  },
  {
    question: "What is peer-to-peer lending?",
    answer:
      "P2P or Peer-to-Peer lending is an online platform connecting borrowers and lenders directly, eliminating intermediaries. Borrowers, whether individuals or businesses, match the criteria set by lenders, creating a symbiotic financial ecosystem. By investing in a P2P platform, your funds are channelled directly into loans for borrowers.",
  },
  {
    question: "How do I start investing in Aditi Investment Plan?",
    answer:
      "<ul><li>Click on the ‘Grow Your Money Wisely’ icon on your Mahila Money App.</li><li>Register with an active mobile number to create your profile.</li><li>Enter and verify your PAN/Aadhar card details.</li><li>Add valid bank account information.</li><li>Enter your investment amount and select any preferred payment mode.</li><li>Earn 9% annual returns with as low as 3 months lock-in period.</li></ul>",
  },
  {
    question: "What is the minimum investment amount?",
    answer: "You can start investing with a minimum amount of INR 3,000.",
  },
  {
    question: "Is it a one-time investment?",
    answer:
      "No. You can keep investing as and when you wish with a minimum amount of INR 3,000 per investment. Please note that the maximum amount of investment in the Aditi Investment Plan is INR 10,00,000.",
  },
  {
    question: "How many times can I invest in a year?",
    answer:
      "You have the flexibility to invest multiple times at your own discretion to build your financial portfolio of up to INR 10,00,000.",
  },
  {
    question: "Who is an “investor”?",
    answer:
      "In this case, the person whose details are entered in the application form -YOU- will be an “investor”.",
  },
  {
    question: "What documents are required to create my profile?",
    answer:
      "<p>No documents will be required to create your profile. However, please keep the following information handy: <ul><li>PAN card number</li><li>Aadhar card number</li><li>Bank account number and IFSC code</li></ul></p>",
  },
  {
    question: "I don’t have a PAN card. Can I invest?",
    answer:
      "Unfortunately, PAN details are mandatory to complete your profile.",
  },
  {
    question: "I don’t have an Aadhar card. Can I invest?",
    answer:
      "Unfortunately, Aadhar details are mandatory to complete your profile.",
  },
  {
    question: "Why are the bank details required?",
    answer:
      "Bank details are required for verification purposes to transfer your earnings and the maturity amount directly into your bank account.",
  },
  {
    question: "Which payment modes are available?",
    answer:
      "<p>You can start investing with the following payment modes: <ul><li>UPI</li><li>Google Pay</li><li>PhonePe</li><li>Netbanking</li><li>Debit card</li><li>Credit card</li></ul></p>",
  },
  {
    question: "How much returns will I get once I invest?",
    answer: "You will earn a 9% annual interest on your investments",
  },
  {
    question: "What does “Lock-in period” mean?",
    answer:
      "The term “lock-in period” means that you cannot withdraw your investment amount during this time.",
  },
  {
    question: "Does Aditi Investment Plan have a lock-in period?",
    answer:
      "Yes, the lock-in period of the “Aditi Investment Plan” is three (3) months.",
  },
  {
    question: "How can I monitor my portfolio?",
    answer:
      "After you log in to your Aditi Investment Plan account, you can view and manage your portfolio through the Investor Dashboard. ",
  },
  {
    question: "How can I withdraw my investment? ",
    answer:
      "You can withdraw your investment after the lock-in period is over by clicking on 'Withdraw Funds' in the left menu after logging into your investment profile on the Mahila Money app.",
  },
  {
    question: "How do I reach out in case of any issues?",
    answer: "You can write to us at customercare@mahila.money with your query.",
  },
];

const introWomensList = [
  {
    // red-dress
    imgUrl: AppIcons.imgAditiPerson1,
    imgWidth: window.innerWidth * 0.1,
    imgStyle: { position: "absolute", left: "0%", top: "25%" },
  },
  {
    // yellow-saree-dress
    imgUrl: AppIcons.imgAditiPerson2,
    imgWidth: window.innerWidth * 0.09,
    imgStyle: { position: "absolute", left: "17%", top: "5%", zIndex: 2 },
  },
  {
    // black-dress
    imgUrl: AppIcons.imgAditiPerson3,
    imgWidth: window.innerWidth * 0.088,
    imgStyle: {
      position: "absolute",
      left: "19%",
      top: "48%",
    },
  },
  {
    // orange-dress
    imgUrl: AppIcons.imgAditiPerson4,
    imgWidth: window.innerWidth * 0.08,
    imgStyle: { position: "absolute", right: "24%", top: "20%", zIndex: 2 },
  },
  {
    // yellow-dress
    imgUrl: AppIcons.imgAditiPerson6,
    imgWidth: window.innerWidth * 0.14,
    imgStyle: { position: "absolute", right: "4%", top: "38%" },
  },
  {
    // pink-dress
    imgUrl: isMobile ? "" : AppIcons.imgAditiPerson5,
    imgWidth: window.innerWidth * 0.083,
    imgStyle: { position: "absolute", right: "3%", top: "-7%", zIndex: 2 },
  },
];

function formatIndianCurrencyFormat(amount) {
  // Convert amount to string
  let amountStr = String(amount);

  // Split the amount into integer and decimal parts
  let parts = amountStr.split(".");

  // If there are decimal parts
  if (parts.length > 1) {
    let integerPart = parts[0];
    let decimalPart = parts[1];

    // Format integer part with commas
    integerPart = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

    // Return formatted amount with only two decimal places
    return `${integerPart}.${decimalPart.slice(0, 2)}`;
  } else {
    // If no decimal part, just format integer part with commas
    return amountStr.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  }
}

const amountMarks = [
  {
    amount: 3000,
    value: 10,
    label: "₹3k",
  },
  {
    amount: 10000,
    value: 20,
    label: "₹10k",
  },
  {
    amount: 25000,
    value: 30,
    label: "₹25k",
  },
  {
    amount: 100000,
    value: 40,
    label: "₹1L",
  },
  {
    amount: 250000,
    value: 50,
    label: "₹2.5L",
  },
  {
    amount: 1000000,

    value: 60,
    label: "₹10L",
  },
];

const timePeriodMarks = [
  {
    value: 3,
    label: "3m",
  },
  {
    value: 6,
    label: "6m",
  },
  {
    value: 9,
    label: "9m",
  },
  {
    value: 12,
    label: "12m",
  },
];

export {
  graphList,
  videoCarousel,
  mutualFundsList,
  stepsList,
  aditiFaqsList,
  introWomensList,
  timePeriodMarks,
  amountMarks,
  formatIndianCurrencyFormat,
};
